var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5889 22.6298C11.9189 22.6298 11.2389 22.4798 10.7089 22.1698L5.20886 18.9998C2.96886 17.4898 2.82886 17.2598 2.82886 14.8898V9.1098C2.82886 6.7398 2.95886 6.5098 5.15886 5.0198L10.6989 1.8198C11.7489 1.2098 13.3989 1.2098 14.4489 1.8198L19.9689 4.9998C22.2089 6.5098 22.3489 6.7398 22.3489 9.1098V14.8798C22.3489 17.2498 22.2189 17.4798 20.0189 18.9698L14.4789 22.1698C13.9389 22.4798 13.2589 22.6298 12.5889 22.6298ZM12.5889 2.8698C12.1689 2.8698 11.7589 2.9498 11.4689 3.1198L5.96886 6.2998C4.33886 7.3998 4.33886 7.3998 4.33886 9.1098V14.8798C4.33886 16.5898 4.33886 16.5898 6.00886 17.7198L11.4689 20.8698C12.0589 21.2098 13.1289 21.2098 13.7189 20.8698L19.2189 17.6898C20.8389 16.5898 20.8389 16.5898 20.8389 14.8798V9.1098C20.8389 7.3998 20.8389 7.3998 19.1689 6.2698L13.7089 3.1198C13.4189 2.9498 13.0089 2.8698 12.5889 2.8698Z",
    fill: "#6A6077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5889 15.75C10.5189 15.75 8.83887 14.07 8.83887 12C8.83887 9.93 10.5189 8.25 12.5889 8.25C14.6589 8.25 16.3389 9.93 16.3389 12C16.3389 14.07 14.6589 15.75 12.5889 15.75ZM12.5889 9.75C11.3489 9.75 10.3389 10.76 10.3389 12C10.3389 13.24 11.3489 14.25 12.5889 14.25C13.8289 14.25 14.8389 13.24 14.8389 12C14.8389 10.76 13.8289 9.75 12.5889 9.75Z",
    fill: "#6A6077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.98c7bde48d4a9ff5911d9ac47ca2f042.svg";
export { ForwardRef as ReactComponent };